export default "__VITE_ASSET__DUZmq7oO__"